import { Mail } from 'lucide-react';

/**
 * Single row in the merchants table with all action buttons.
 * Receives callbacks for each operation; doesn't manage state itself.
 */
export default function MerchantRow({
  merchant: m,
  onOpenProjects, onOpenStatus, onOpenFee, onOpenPassword, onOpenConcentrator,
  onOpenTolerance,
  onDownloadCredentials, onResendEmail, onDownloadGuide,
  onOpenDelete, onOpenPurge,
  sendingEmail,
}) {
  return (
    <tr className="hover:bg-gray-50">
      <td className="px-6 py-4">
        <p className="text-sm font-medium">{m.company_name}</p>
        {m.projects?.length > 0 && (
          <p className="text-xs text-gray-500 mt-1">{m.projects.map((p) => p.project_name).join(', ')}</p>
        )}
      </td>
      <td className="px-6 py-4 text-sm text-gray-600">{m.email}</td>
      <td className="px-6 py-4">
        <span className="px-2 py-1 text-xs font-medium bg-purple-100 text-purple-800 rounded-full">{m.role}</span>
      </td>
      <td className="px-6 py-4 text-sm text-center font-semibold" style={{ color: '#003594' }}>{m.projects_count}</td>
      <td className="px-6 py-4 text-sm font-semibold">VES {m.balance.toFixed(2)}</td>
      <td className="px-6 py-4 text-sm">{m.fee_percentage}%</td>
      <td className="px-6 py-4 text-sm" data-testid={`tolerance-cell-${m.user_id}`}>
        {m.overpay_tolerance_ves
          ? <span className="px-2 py-1 text-xs font-medium bg-amber-100 text-amber-800 rounded-full">+{m.overpay_tolerance_ves} Bs</span>
          : <span className="text-xs text-gray-400">—</span>}
      </td>
      <td className="px-6 py-4">
        <span className={`px-2 py-1 text-xs rounded-full ${
          m.status === 'active' ? 'bg-green-100 text-green-800'
            : m.status === 'pending' ? 'bg-yellow-100 text-yellow-800'
              : 'bg-gray-100 text-gray-800'
        }`}>{m.status}</span>
      </td>
      <td className="px-6 py-4">
        <div className="flex gap-1 flex-wrap">
          <button onClick={onOpenProjects} className="px-2 py-1 text-xs text-white rounded" style={{ backgroundColor: '#008AD8' }}>Ver</button>
          <button onClick={onOpenStatus} className="px-2 py-1 text-xs bg-yellow-100 text-yellow-800 rounded hover:bg-yellow-200">Estado</button>
          <button onClick={onOpenFee} className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded hover:bg-blue-200">Fee</button>
          <button
            data-testid={`tolerance-${m.user_id}`}
            onClick={onOpenTolerance}
            title="Tolerancia de sobrepago en Bs"
            className="px-2 py-1 text-xs bg-amber-100 text-amber-800 rounded hover:bg-amber-200"
          >Tol.</button>
          <button onClick={onOpenPassword} className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded hover:bg-red-200">Pass</button>
          <button onClick={() => onDownloadCredentials('pdf')} className="px-2 py-1 text-xs bg-indigo-100 text-indigo-800 rounded hover:bg-indigo-200">PDF</button>
          <button onClick={() => onDownloadCredentials('xlsx')} className="px-2 py-1 text-xs bg-teal-100 text-teal-800 rounded hover:bg-teal-200">XLS</button>
          <button
            data-testid={`resend-email-${m.user_id}`}
            onClick={onResendEmail}
            disabled={sendingEmail}
            className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded hover:bg-green-200 disabled:opacity-50 flex items-center gap-1"
          >
            <Mail className="w-3 h-3" />{sendingEmail ? '...' : 'Email'}
          </button>
          <button data-testid={`concentrator-${m.user_id}`} onClick={onOpenConcentrator} className="px-2 py-1 text-xs bg-orange-100 text-orange-800 rounded hover:bg-orange-200">Conc.</button>
          <button data-testid={`delete-${m.user_id}`} onClick={onOpenDelete} className="px-2 py-1 text-xs bg-red-100 text-red-700 rounded hover:bg-red-200" title="Eliminar (soft delete, reversible)">Eliminar</button>
          <button data-testid={`purge-${m.user_id}`} onClick={onOpenPurge} className="px-2 py-1 text-xs bg-red-700 text-white rounded hover:bg-red-800" title="Purgar permanentemente (no reversible)">Purgar</button>
          <button onClick={() => onDownloadGuide('md')} className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200">.md</button>
          <button onClick={() => onDownloadGuide('pdf')} className="px-2 py-1 text-xs bg-purple-100 text-purple-800 rounded hover:bg-purple-200">Guia</button>
        </div>
      </td>
    </tr>
  );
}
